<template>
	<div class="text-start roboto-flex-medium">
		<h2 class="mb-2 text-indigo-700 text-xl">⚠️ P0004: Fuel Volume Regulator A Control Circuit High</h2>
		<p class="mb-4">This code indicates that the fuel volume regulator circuit is pulling too much voltage—like shouting when a whisper would do. 🔊</p>
		<p class="mb-4">Potential causes? Shorted wiring, a stuck-open fuel volume regulator, or a failing PCM.</p>
		<p class="mb-4">The result: rough idling, poor performance, or hard starts. It's worth digging into with a multimeter and a little patience. 🔧📉</p>
	</div>
</template>
